import { StartNode, startNodeFeatures } from './start-node';
import {TaskNode,taskNodeFeatures} from './task-node/task-node';

export const nodeTypes = {
  task: TaskNode,
  start: StartNode,
};

export const nodeFeatures = {
  task: taskNodeFeatures,
  start: startNodeFeatures
};

export type MyNodeTypes = keyof typeof nodeTypes;
